import React, { useState, useEffect } from "react";
import "./Gallery.css";

const ImageSlider = ({ title, largeImage, smallImage }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % largeImage.length
      );
    }, 5000); 

    return () => clearInterval(interval);
  }, [largeImage]);

  return (
    <div className="service-image-slider">
      <div 
        className="slider-inner"
        style={{
          transform: `translateX(-${currentImageIndex * 100}%)`,
        }}
      >
        {largeImage.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={title}
            title={title}
            className="slider-image"
          />
        ))}
      </div>
      
      {/* 滑动指示器 */}
      <div className="slider-indicators">
        {largeImage.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
            onClick={() => setCurrentImageIndex(index)}
            aria-label={`查看图片 ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export const Gallery = (props) => {
  return (
    <div id="our-services">
      <div className="container">
        {/* Section Header */}
        <div className="row">
          <div className="col-xs-12">
            <div className="section-header text-center">
              <h2>私たちのソリューション</h2>
              <div className="section-subtitle">
                <span className="highlight-text">最先端AI技術</span>で企業の課題を解決
              </div>
              <p className="section-description">
                株式会社ReCoPilotは、革新的なレコメンドシステムと生成AIソリューションを通じて、
                お客様のビジネス効率化と競争力向上を実現します。
              </p>
            </div>
          </div>
        </div>

        {/* Services Showcase */}
        <div className="services-showcase">
          {props.data && props.data.map((service, index) => (
            <div
              key={`${service.title}-${index}`}
              className={`service-item ${index % 2 === 1 ? 'reverse' : ''}`}
            >
              <div className="row align-items-center">
                <div className="col-xs-12 col-md-7">
                  <div className="service-image-container">
                    <ImageSlider
                      title={service.title}
                      largeImage={service.largeImage}
                      smallImage={service.smallImage}
                    />
                  </div>
                </div>
                <div className="col-xs-12 col-md-5">
                  <div className="service-content">
                    <div className="service-number">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    <h3 className="service-title">{service.title}</h3>
                    <div className="service-features">
                      <div className="feature-item">
                        <i className="fa fa-check-circle"></i>
                        <span>{service.text1}</span>
                      </div>
                      <div className="feature-item">
                        <i className="fa fa-check-circle"></i>
                        <span>{service.text2}</span>
                      </div>
                    </div>
                    
                    {/* 添加服务优势标签 */}
                    <div className="service-tags">
                      {index === 0 && (
                        <>
                          <span className="tag">SEO最適化</span>
                          <span className="tag">価格モニタリング</span>
                          <span className="tag">EC支援</span>
                        </>
                      )}
                      {index === 1 && (
                        <>
                          <span className="tag">専門情報抽出</span>
                          <span className="tag">AIデータ解析</span>
                          <span className="tag">製薬業界特化</span>
                        </>
                      )}
                      {index === 2 && (
                        <>
                          <span className="tag">カスタム開発</span>
                          <span className="tag">多業界対応</span>
                          <span className="tag">柔軟なサポート</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>


      </div>
    </div>
  );
};
